import { Injectable, inject } from '@angular/core'
import { ConfigService } from './config.service'
import { ClientService } from './client.service'
import { LogService } from './log.service'
import { FilterService } from './filter.service'
import { CurrencyService } from './currency.service'
import { GlobalDataService } from './global-data.service'
import { ComparisonService } from './comparison.service'

@Injectable({
  providedIn: 'root',
})
export class DevService {
  private logger = inject(LogService)
  private configService = inject(ConfigService)
  private clientService = inject(ClientService)
  private filterService = inject(FilterService)
  private currencyService = inject(CurrencyService)
  private globalData = inject(GlobalDataService)
  private comparisonService = inject(ComparisonService)


  init(): void {
    (window as any).signals = () => this.signals()
  }

  signals(): void {
    this.logger.debug('Client: ', this.clientService.client())
    this.logger.debug('Config: ', this.configService.config())
    this.logger.debug('Config Metadata ', this.configService.configMetadata ? this.configService.configMetadata() : null)
    this.logger.debug('Filters ', this.filterService.filters())
    this.logger.debug('All Currencies ', this.currencyService.allCurrencies())
    this.logger.debug('Loaded Currencies ', this.currencyService.loadedCurrencies())
    this.logger.debug('Default Currency ', this.globalData.defaultCurrency())
    this.logger.debug('Selected Currency ', this.currencyService.selectedCurrency())
    this.logger.debug('Comparison assets ', this.comparisonService.assets())
  }
}
